import { Box, ChakraProvider, extendTheme, useTheme } from '@chakra-ui/react'
import { ReactNode, useMemo } from 'react'
import { TYPO_BODY } from '@/lib/typography'

type ContentAreaProps = {
  children: ReactNode
}

/**
 * Main scrollable content shell. Typography and control sizes align with the
 * compact sidebar/header (sm body, sm form controls).
 */
export function ContentArea({ children }: ContentAreaProps) {
  const parentTheme = useTheme()

  const contentTheme = useMemo(
    () =>
      extendTheme(parentTheme, {
        components: {
          Button: { defaultProps: { size: 'sm' } },
          Input: { defaultProps: { size: 'sm' } },
          NumberInput: { defaultProps: { size: 'sm' } },
          Select: { defaultProps: { size: 'sm' } },
          Textarea: { defaultProps: { size: 'sm' } },
          FormLabel: { baseStyle: { fontSize: TYPO_BODY } },
          Table: { defaultProps: { size: 'sm' } },
          Tabs: { defaultProps: { size: 'sm' } },
          Badge: { baseStyle: { fontSize: TYPO_BODY } },
        },
      }),
    [parentTheme],
  )

  return (
    <ChakraProvider theme={contentTheme}>
      <Box
        as="main"
        flex="1"
        overflowY="auto"
        overflowX="hidden"
        position="relative"
        fontSize={TYPO_BODY}
        lineHeight="short"
      >
        {children}
      </Box>
    </ChakraProvider>
  )
}
